import { useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function RazorpayPayButton({ chartId, plan, amount }) {

  const [loading, setLoading] = useState(false);

  const startPayment = async () => {

    if (loading) return;

    setLoading(true);

    try {

      const res = await fetch(`${API_BASE}/payment/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          chart_id: chartId,
          plan: plan.toLowerCase()
        })
      });

      const data = await res.json();

      if (!data.order_id) {
        alert("Failed to create payment order.");
        setLoading(false);
        return;
      }

      const options = {
        key: data.key_id,
        amount: data.amount,
        currency: data.currency,
        order_id: data.order_id,

        name: "SysMindX Astro",
        description: `${plan} plan unlock`,

        prefill: {
          name: "SysMindX User"
        },

        handler: async function (response) {

          const verify = await fetch(`${API_BASE}/payment/verify`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              chart_id: chartId,
              plan: plan.toLowerCase(),
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature
            })
          });

          const verifyData = await verify.json();

          if (verifyData.status === "ok") {

            window.location.href =
              `/unlock?code=${verifyData.unlock_code}&chart_id=${chartId}`;

          } else {

            alert("Payment verification failed. Please contact support.");

          }
        },

        theme: {
          color: "#fbbf24"
        }
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function () {
        alert("Payment failed. Please try again.");
      });

      console.log("Opening Razorpay", options);

      rzp.open();

    } catch (err) {

      console.error(err);
      alert("Unable to start payment.");

    }

    setLoading(false);
  };

  return (
    <button className="pay-btn" onClick={startPayment}>
      {loading ? "Preparing payment..." : `Pay ₹${amount}`}
    </button>
  );
}
